/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCategoryModel = /* GraphQL */ `
  query GetCategoryModel($id: ID!) {
    getCategoryModel(id: $id) {
      id
      nameTA
      nameEN
      isFeatured
      children {
        nextToken
        __typename
      }
      primaryVideos {
        nextToken
        __typename
      }
      secondaryVideos {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      categoryModelChildrenId
      __typename
    }
  }
`;
export const listCategoryModels = /* GraphQL */ `
  query ListCategoryModels(
    $filter: ModelCategoryModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoryModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVideoModel = /* GraphQL */ `
  query GetVideoModel($id: ID!) {
    getVideoModel(id: $id) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      status
      titleEN
      titleTA
      descriptionTA
      duration
      likesCount
      dislikesCount
      commentsCount
      primaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      secondaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
      viewsCount
      publishState
      significantDate
      isFeatured
      descriptionEN
      errorMessage
      size
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      notifications {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      tags {
        nextToken
        __typename
      }
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listVideoModels = /* GraphQL */ `
  query ListVideoModels(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const videosByOwner = /* GraphQL */ `
  query VideosByOwner(
    $ownerId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videosByOwner(
      ownerId: $ownerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const videosByStatus = /* GraphQL */ `
  query VideosByStatus(
    $status: VideoStatus!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videosByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const topVideosByStatus = /* GraphQL */ `
  query TopVideosByStatus(
    $status: VideoStatus!
    $viewsCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    topVideosByStatus(
      status: $status
      viewsCount: $viewsCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const videosByPublishState = /* GraphQL */ `
  query VideosByPublishState(
    $publishState: PublishState!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videosByPublishState(
      publishState: $publishState
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const topVideosByPublishState = /* GraphQL */ `
  query TopVideosByPublishState(
    $publishState: PublishState!
    $viewsCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    topVideosByPublishState(
      publishState: $publishState
      viewsCount: $viewsCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserModel = /* GraphQL */ `
  query GetUserModel($id: ID!) {
    getUserModel(id: $id) {
      id
      username
      createdAt
      email
      lastName
      passwordHash
      ipAddress
      emailVerified
      status
      firstName
      displayName
      gender
      birthday
      fbId
      twitterId
      instagramId
      linkedInId
      clubHouseId
      interestedCategories {
        nextToken
        __typename
      }
      phone
      paypalEmail
      viewsCount
      videos {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      country
      bio
      isPro
      lastActiveAt
      subscribersCount
      likedVideosCount
      subscribers {
        nextToken
        __typename
      }
      subscribedTo {
        nextToken
        __typename
      }
      blockers {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      commentInteractions {
        nextToken
        __typename
      }
      legacyAvatar
      legacyCover
      legacyId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listUserModels = /* GraphQL */ `
  query ListUserModels(
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByUsername = /* GraphQL */ `
  query UserByUsername(
    $username: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByUsername(
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersByStatus = /* GraphQL */ `
  query UsersByStatus(
    $status: UserStatus!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersBySubscribersCount = /* GraphQL */ `
  query UsersBySubscribersCount(
    $status: UserStatus!
    $subscribersCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersBySubscribersCount(
      status: $status
      subscribersCount: $subscribersCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByLegacyId = /* GraphQL */ `
  query UserByLegacyId(
    $legacyId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByLegacyId(
      legacyId: $legacyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserSubscriber = /* GraphQL */ `
  query GetUserSubscriber($id: ID!) {
    getUserSubscriber(id: $id) {
      id
      subscriber {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscriberId
      subscribedTo {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscribedToId
      notify
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listUserSubscribers = /* GraphQL */ `
  query ListUserSubscribers(
    $filter: ModelUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSubscribers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subscriberId
        subscribedToId
        notify
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscribersBySubscriberId = /* GraphQL */ `
  query SubscribersBySubscriberId(
    $subscriberId: ID!
    $subscribedToId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscribersBySubscriberId(
      subscriberId: $subscriberId
      subscribedToId: $subscribedToId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subscriberId
        subscribedToId
        notify
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscribersBySubscribedToId = /* GraphQL */ `
  query SubscribersBySubscribedToId(
    $subscribedToId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscribersBySubscribedToId(
      subscribedToId: $subscribedToId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subscriberId
        subscribedToId
        notify
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserBlocked = /* GraphQL */ `
  query GetUserBlocked($id: ID!) {
    getUserBlocked(id: $id) {
      id
      blocker {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockerId
      blockedUser {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockedUserId
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listUserBlockeds = /* GraphQL */ `
  query ListUserBlockeds(
    $filter: ModelUserBlockedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserBlockeds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        blockerId
        blockedUserId
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blockedByUser = /* GraphQL */ `
  query BlockedByUser(
    $blockerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserBlockedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blockedByUser(
      blockerId: $blockerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blockerId
        blockedUserId
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blockersOfUser = /* GraphQL */ `
  query BlockersOfUser(
    $blockedUserId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserBlockedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blockersOfUser(
      blockedUserId: $blockedUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blockerId
        blockedUserId
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommentModel = /* GraphQL */ `
  query GetCommentModel($id: ID!) {
    getCommentModel(id: $id) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      replyTo {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      replyToId
      message
      likesCount
      dislikesCount
      replies {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      updatedAt
      commentModelRepliesId
      authOwner
      __typename
    }
  }
`;
export const listCommentModels = /* GraphQL */ `
  query ListCommentModels(
    $filter: ModelCommentModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommentModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotificationModel = /* GraphQL */ `
  query GetNotificationModel($id: ID!) {
    getNotificationModel(id: $id) {
      id
      createdAt
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      type
      profile {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      profileId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      message {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      messageId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      updatedAt
      videoModelNotificationsId
      commentModelNotificationsId
      __typename
    }
  }
`;
export const listNotificationModels = /* GraphQL */ `
  query ListNotificationModels(
    $filter: ModelNotificationModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByUser = /* GraphQL */ `
  query NotificationsByUser(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessageModel = /* GraphQL */ `
  query GetMessageModel($id: ID!) {
    getMessageModel(id: $id) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      sender {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      receiver {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      isRead
      lastMessageAt
      notification {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      messageModelNotificationId
      __typename
    }
  }
`;
export const listMessageModels = /* GraphQL */ `
  query ListMessageModels(
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesBySender = /* GraphQL */ `
  query MessagesBySender(
    $senderId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesBySender(
      senderId: $senderId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByReceiver = /* GraphQL */ `
  query MessagesByReceiver(
    $receiverId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiver(
      receiverId: $receiverId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByConversation = /* GraphQL */ `
  query MessagesByConversation(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversation(
      conversationId: $conversationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesBySenderAuthOwner = /* GraphQL */ `
  query MessagesBySenderAuthOwner(
    $senderAuthOwner: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesBySenderAuthOwner(
      senderAuthOwner: $senderAuthOwner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByReceiverAuthOwner = /* GraphQL */ `
  query MessagesByReceiverAuthOwner(
    $receiverAuthOwner: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiverAuthOwner(
      receiverAuthOwner: $receiverAuthOwner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVideoInteractionModel = /* GraphQL */ `
  query GetVideoInteractionModel($id: ID!) {
    getVideoInteractionModel(id: $id) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      watchPercentage
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listVideoInteractionModels = /* GraphQL */ `
  query ListVideoInteractionModels(
    $filter: ModelVideoInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoInteractionModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        videoId
        watchPercentage
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionByType = /* GraphQL */ `
  query InteractionByType(
    $type: InteractionType!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionByType(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        videoId
        watchPercentage
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionByUserId = /* GraphQL */ `
  query InteractionByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        videoId
        watchPercentage
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionByUserAndVideo = /* GraphQL */ `
  query InteractionByUserAndVideo(
    $userId: ID!
    $videoId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionByUserAndVideo(
      userId: $userId
      videoId: $videoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        videoId
        watchPercentage
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommentInteractionModel = /* GraphQL */ `
  query GetCommentInteractionModel($id: ID!) {
    getCommentInteractionModel(id: $id) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      videoId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listCommentInteractionModels = /* GraphQL */ `
  query ListCommentInteractionModels(
    $filter: ModelCommentInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommentInteractionModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        commentId
        videoId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentInteractionByType = /* GraphQL */ `
  query CommentInteractionByType(
    $type: InteractionType!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentInteractionByType(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        commentId
        videoId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentInteractionByUserId = /* GraphQL */ `
  query CommentInteractionByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentInteractionByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        commentId
        videoId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentInteractionByUserAndVideo = /* GraphQL */ `
  query CommentInteractionByUserAndVideo(
    $userId: ID!
    $videoId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentInteractionByUserAndVideo(
      userId: $userId
      videoId: $videoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        type
        userId
        commentId
        videoId
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTagModel = /* GraphQL */ `
  query GetTagModel($id: ID!) {
    getTagModel(id: $id) {
      id
      label
      videos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTagModels = /* GraphQL */ `
  query ListTagModels(
    $filter: ModelTagModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTagModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tagByLabel = /* GraphQL */ `
  query TagByLabel(
    $label: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTagModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tagByLabel(
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserCategories = /* GraphQL */ `
  query GetUserCategories($id: ID!) {
    getUserCategories(id: $id) {
      id
      categoryModelID
      userModelID
      categoryModel {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      userModel {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listUserCategories = /* GraphQL */ `
  query ListUserCategories(
    $filter: ModelUserCategoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        categoryModelID
        userModelID
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVideoTags = /* GraphQL */ `
  query GetVideoTags($id: ID!) {
    getVideoTags(id: $id) {
      id
      videoModelID
      tagModelID
      videoModel {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      tagModel {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const listVideoTags = /* GraphQL */ `
  query ListVideoTags(
    $filter: ModelVideoTagsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        videoModelID
        tagModelID
        createdAt
        updatedAt
        authOwner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const adminConsoleQuery = /* GraphQL */ `
  query AdminConsoleQuery($action: String!, $input: AWSJSON) {
    adminConsoleQuery(action: $action, input: $input)
  }
`;
export const getRecommendations = /* GraphQL */ `
  query GetRecommendations($videoId: ID!, $userId: ID, $limit: Int) {
    getRecommendations(videoId: $videoId, userId: $userId, limit: $limit) {
      items {
        id
        titleEN
        titleTA
        duration
        viewsCount
        likesCount
        commentsCount
        imageName
        thumbnailUrl
        createdAt
        isFeatured
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        ownerId
        ownerUsername
        ownerDisplayName
        ownerLegacyAvatar
        score
        matchReasons
        __typename
      }
      source
      __typename
    }
  }
`;
